// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__q75O4","filesListContainer":"PosDisputesFiles_filesListContainer__3VVM2","filesButton":"PosDisputesFiles_filesButton__1X2zx"};